/**
 * @file ジャンル数確認
 */
'use strict';

/**
 * @classname CheckGenreNum
 * @classdesc ジャンル数確認
 */
export default class CheckGenreNum {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('CheckGenreNum.constructor');
		this._$e = $e;
        $e.on('click', ()  => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof CheckGenreNum
	 * @return {undefined}
	 */
	onClick() {
		console.log('CheckGenreNum.onClick');
        let checked = 0;
        const $genreNum = $('.genre-num');
        $genreNum.each((idx, e) => {
            const $e = $(e);
            if($e.prop('checked')) checked ++
        });
        if(checked > 3) $genreNum.addClass('is-invalid');
	};
}
